import { HTMLAttributes, memo } from 'react';
import './index.style.scss';

const Badge = (props: HTMLAttributes<HTMLSpanElement>) => {
  const { className, children } = props;
  return <span className={`badge-wrapper ${className}`}>{children}</span>;
};

export default memo(Badge);
